function setupAccordion(accordionItemsSelector, accordionLinksSelector, itemOpenClass, itemCloseClass, iconSelector) {
	const accordionItems = document.querySelectorAll(accordionItemsSelector);
	const accordionLinks = document.querySelectorAll(accordionLinksSelector);

	if (accordionItems.length === 1) {
		accordionItems[0].classList.add(itemOpenClass);
		accordionItems[0].classList.remove(itemCloseClass);

		const icon = accordionItems[0].querySelector(iconSelector);
		if (icon) icon.style.display = "none";
	} else {
		accordionLinks.forEach(link => {
			link.addEventListener('click', function () {
				const parentItem = link.closest(accordionItemsSelector);

				// Если текущий элемент открыт, закрыть его
				if (parentItem && parentItem.classList.contains(itemOpenClass)) {
					parentItem.classList.remove(itemOpenClass);
					parentItem.classList.add(itemCloseClass);
				} else {
					// Закрыть все элементы
					accordionItems.forEach(item => {
						item.classList.add(itemCloseClass);
						item.classList.remove(itemOpenClass);
					});

					// Открыть текущий элемент
					if (parentItem) {
						parentItem.classList.add(itemOpenClass);
						parentItem.classList.remove(itemCloseClass);
					}
				}
			});
		});
	}
}

// Настройка для основного аккордеона
setupAccordion(
	'.accordion__item',
	'.accordion__title',
	'accordion__item_open',
	'accordion__item_close',
	'.accordion__icon'
);

// Настройка для вложенного аккордеона
setupAccordion(
	'.sub-accordion__item',
	'.sub-accordion__title',
	'sub-accordion__item_open',
	'sub-accordion__item_close',
	'.accordion__icon'
);
